module.exports = "/_next/static/images/5f6c6515e894ec6c62fc5a0daa9a9868-nubank-outdoor-xs@1x.jpg";